// extracted by mini-css-extract-plugin
export default {"grid":"Feature_grid__JdcIV"};